// import React, { useEffect, useState } from "react";
// import PredictionContext from "./predictionContext";

// const PredictionProvider = ({ children }) => {
//   const [prediction, setPrediction] = useState({
//     newPrediction: false,
//     selectCountry: null,
//     electionTypeData: { state: null, type: null },
//     prediction: null,
//     freshPredict: false,
//   });

//   return (
//     <PredictionContext.Provider value={{ prediction, setPrediction }}>
//       {children}
//     </PredictionContext.Provider>
//   );
// };

// export default PredictionProvider;

// PredictionProvider.js
import React, { useState } from "react";
import PredictionContext from "./predictionContext";
import { defaultPrediction, setStep } from "./predictionHelpers";

const PredictionProvider = ({ children }) => {
  const [prediction, setPrediction] = useState(defaultPrediction);
  const resetPrediction = () => {
    setPrediction({ ...defaultPrediction });
  };
  const updatePredictionStep = (step, payload = {}) => {
    setPrediction(setStep(step, payload));
  };

  return (
    <PredictionContext.Provider
      value={{
        prediction,
        setPrediction,
        resetPrediction,
        updatePredictionStep,
      }}
    >
      {children}
    </PredictionContext.Provider>
  );
};

export default PredictionProvider;
